import { Box, CircularProgress, Typography } from '@mui/material';
import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import { sxCircularProgressCenter, sxTitle } from '../../../assets/styles/CommonSxProps';
import VoltarButton from '../../../components/Accessibility/VoltarButton';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { getConhecaOPrograma } from '../../../services/SaudeBemEstar/GestaoDeCronicosService';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { sxDarkGreyBody } from '../../MeuPlano/PermissoesVisualizacao/sxProps';

const ConhecaOPrograma: React.FC = () => {

  const accessibility = useAccessibility();

  const [htmlText, setHtmlText] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const fetchConhecaOPrograma = async () => {
    setLoading(true);
    const response = await getConhecaOPrograma();
    if (response?.status === 200) {
      setHtmlText(response.data.texto);
    } else {
      console.error(response);
      openModalError('Erro ao consultar informações do Gestão de Crônicos', 'Tente novamente em instantes.');
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchConhecaOPrograma();
  }, []);

  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Fechar',
      showButtonModal: true,
      closeAction: () => setModalFeedback(null),
      buttonAction: () => setModalFeedback(null)
    });
  }

  return (
    <>
      {loading && <CircularProgress sx={sxCircularProgressCenter} />}
      <Box maxWidth={'570px'}>
        <Typography sx={sxTitle} style={accessibility.textTitleStyleAccessibility} component={'h1'}>
          Conheça o Gestão de Crônicos
        </Typography>
        <br />
        <span>
          <Typography style={accessibility.textStyleAccessibility} sx={sxDarkGreyBody}>{parse(htmlText)}</Typography>
        </span>
        <VoltarButton onClick={() => window.history.back()} />
      </Box>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default ConhecaOPrograma;